import React, { FC, HTMLProps } from 'react';
import styles from './title.module.scss';
import { Hyperlink } from '../Hyperlink';

type Props = HTMLProps<HTMLAnchorElement>;

export const EntitiesTitleLink: FC<Props> = props => (
  <Hyperlink {...props} className={styles.title} />
);
